import { Rule } from "antd/lib/form";

export const rules: Rule[] = [{ required: true, message: "Bắt buộc" }];
